package ru.chm.gradereport.ui.screens.course.sheet

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ru.chm.gradereport.ui.components.PrimaryButton
import ru.chm.gradereport.ui.components.SecondaryButton
import ru.chm.gradereport.ui.theme.GradeTheme

@OptIn(ExperimentalLayoutApi::class)
@Composable
internal fun SheetEditorPanel(
    canAddHomework: Boolean,
    onAddSessionClick: () -> Unit,
    onAddHomeworkClick: () -> Unit,
    onCheckInQrClick: () -> Unit = {},
    onSubmissionsClick: () -> Unit = {},
) {
    val colors = GradeTheme.colors
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(bottom = 10.dp)
            .background(colors.card, RoundedCornerShape(12.dp))
            .border(1.dp, colors.border, RoundedCornerShape(12.dp))
            .padding(12.dp),
        verticalArrangement = Arrangement.spacedBy(10.dp),
    ) {
        FlowRow(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            PrimaryButton(text = "+ Занятие", onClick = onAddSessionClick)
            SecondaryButton(
                text = "+ ДЗ",
                enabled = canAddHomework,
                onClick = onAddHomeworkClick,
            )
            SecondaryButton(
                text = "Ответы на ДЗ",
                enabled = canAddHomework,
                onClick = onSubmissionsClick,
            )
            SecondaryButton(
                text = "QR посещаемость",
                enabled = canAddHomework,
                onClick = onCheckInQrClick,
            )
        }
        Text(
            "Посещаемость: П — присутствовал · Н — не был · О — опоздал · У — уважительная · " +
                "фиолетовая · — самоотметка (подтвердите кликом)",
            color = colors.textMuted,
            fontSize = 13.sp,
        )
        Text(
            "Фиолетовая ячейка ДЗ — есть ответ из формы (см. «Ответы на ДЗ»).",
            color = colors.textMuted,
            fontSize = 13.sp,
        )
    }
}
